import Joi from 'joi';

export const recentlyViewedSettingsValidationSchema = {
  showPreviouslyPurchasedItems: Joi.boolean().required(),
  showOutOfStockItems: Joi.boolean().required(),
  numberOfResultsToDisplay: Joi.number().required().min(3).max(30),
  numberOfRecentDaysToDisplay: Joi.number().required().min(1).max(30),
  addToCart: Joi.object({ active: Joi.boolean().required() }),
};
